import React from 'react'
import InvoicesPageLayout from 'container/InvoicesPageLayout'

const Invoices: React.FC = () => {
	return <InvoicesPageLayout />
}

export default Invoices
